import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Input, Row } from 'reactstrap';

interface Props {
  value: string;
  placeholder: string;
  isDisabled: boolean;
  description?: string;
}

const FormSubmitButton: React.FC<Props> = ({ value, placeholder, isDisabled, description }) => {
  const { t } = useTranslation('translation');

  return (
    <Row>
      <Col className="col-12 mt-4">
        <Input
          className="btn-primary"
          type="submit"
          placeholder={t(placeholder)}
          value={t(value)}
          disabled={isDisabled}
        />
      </Col>
      {description && (
        <Col className="col-12 mt-4">
          <span className="field-description">{t(description)}</span>
        </Col>
      )}
    </Row>
  );
};

export default FormSubmitButton;
